<template>
  <div>
    <el-form
      :model="form"
      label-width="80px"
      :inline="true"
      class="demo-form-inline"
      id="form"
    >
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 名称： </el-col>
          <el-col :span="14">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 父节点： </el-col>
          <el-col :span="14">
            <el-select v-model="form.pid" placeholder="请选择">
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 请求地址： </el-col>
          <el-col :span="14">
            <el-input v-model="form.path"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 排序： </el-col>
          <el-col :span="14">
            <el-input v-model="form.sort" placeholder="默认为1"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 备注： </el-col>
          <el-col :span="14">
            <el-input v-model="form.remark"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5" :offset="8">
          <el-button type="primary" @click="sub()"> 确定 </el-button>
        </el-col>
        <el-col :span="5" :offset="3">
          <el-button type="primary" @click="close()"> 取消 </el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "permission",
  props: ["layerid", "edit", "permission"],
  data() {
    return {
      gutter: 20,
      form: {},
      options: [],
    };
  },
  mounted() {
    this.getAllPermission();
    if (this.edit) {
      this.form = this.edit;
    }
  },
  methods: {
    getAllPermission() {
      let list = [];
      for (let i = 0; i < this.permission.length; ++i) {
        if (this.permission[i].pid == 1 || this.permission[i].pid == 0) {
          list.push(this.permission[i]);
        }
      }
      this.options = list;
      this.fullscreenLoading = false;
    },
    sub() {
      let obj = {
        static: false,
      };
      if(this.form.name && this.form.pid && this.form.path && this.form.sort && this.form.remark){
        obj.form = this.form;
        this.$emit("permissionEmit", obj);
        this.form={};
      }else{
        this.$message.error("所有表单为必填项")
      }
    },
    close() {
      let obj = {
        static: false,
      };
      this.$emit("permissionEmit", obj);
      this.form={};
    },
  },
};
</script>

<style scoped lang="scss">
#form {
  .el-col {
    min-height: 40px;
    .el-date-editor {
      width: 100%;
    }
    .label {
      color: #5f6165;
      height: 40px;
      line-height: 38px;
      text-align: right;
      font-size: 14px;
    }
    .el-radio-group {
      margin-top: 14px;
      float: left;
    }
    .ty {
      text-align: left;
      border-radius: 5px;
      background-color: #e2b837;
      height: 50px;
      line-height: 3.5;
    }
  }
  .el-row {
    min-height: 30px;
    margin-bottom: 22px;
  }
  .el-select {
    width: 100%;
  }
}
</style>